/* eslint-disable no-undef */
import React from 'react';
import { PlayerUv } from '../Players/uv/PlayerUv';







const Principal = () => {
    return <PlayerUv />
    // return <PlayerRicm />
    // return <PlayerFwi />
}







export default Principal;